// Centralized static content for the museum-editorial site.
// Media URLs come from the design_guidelines curation.

export const CATEGORIES = [
  {
    slug: "family-tree",
    name: "Family Tree",
    kicker: "Chapter I",
    blurb: "Lineages, surnames, dynasties and clans traced across generations and continents.",
    count: "12,480 lineages",
    span: "wide", // grid emphasis
    image: "https://images.unsplash.com/photo-1547401372-0ac4589c4d3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxhbmNpZW50JTIwdHJlZSUyMHJvb3RzfGVufDB8fHx8MTc4NTYwNDEwOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "celebrate-a-life",
    name: "Celebrate a Life",
    kicker: "Chapter II",
    blurb: "Living tributes, obituaries and remembrances kept alive by family and community.",
    count: "8,214 tributes",
    span: "tall",
    image: "https://images.pexels.com/photos/1687067/pexels-photo-1687067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
  },
  {
    slug: "heritage",
    name: "Heritage",
    kicker: "Chapter III",
    blurb: "Languages, traditions, temples, cuisine and craft — the texture of belonging.",
    count: "3,097 traditions",
    span: "square",
    image: "https://images.unsplash.com/photo-1561812938-f6e60cbf95e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhbnRpcXVlJTIwZG9jdW1lbnQlMjBoYW5kd3JpdHRlbiUyMGFyY2hpdmV8ZW58MHx8fHwxNzg1NjA0MDk2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "family-history",
    name: "Family History",
    kicker: "Chapter IV",
    blurb: "Timelines, migrations and the quiet chronicles between two names on a tree.",
    count: "24,110 chronicles",
    span: "square",
    image: "https://images.unsplash.com/photo-1637597384611-0c33cef6ec03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxhbnRpcXVlJTIwZG9jdW1lbnQlMjBoYW5kd3JpdHRlbiUyMGFyY2hpdmV8ZW58MHx8fHwxNzg1NjA0MDk2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "memorials",
    name: "Memorials",
    kicker: "Chapter V",
    blurb: "Digital shrines. Anniversaries observed. Candles that never burn out.",
    count: "6,880 memorials",
    span: "wide",
    image: "https://images.unsplash.com/photo-1760201656695-76e8765eef67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxwZWFjZWZ1bCUyMG5hdHVyZSUyMG1lbW9yaWFsfGVufDB8fHx8MTc4NTYwNDA5Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "obituaries",
    name: "Obituaries",
    kicker: "Chapter VI",
    blurb: "Respectful, researched notices — written to endure the century.",
    count: "11,205 notices",
    span: "square",
    image: "https://images.unsplash.com/photo-1723066977799-8d61c2e7e49c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxwZWFjZWZ1bCUyMG5hdHVyZSUyMG1lbW9yaWFsfGVufDB8fHx8MTc4NTYwNDA5Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "historical-families",
    name: "Historical Families",
    kicker: "Chapter VII",
    blurb: "Royal houses, freedom fighters, artisan guilds, business dynasties.",
    count: "1,742 houses",
    span: "tall",
    image: "https://images.unsplash.com/photo-1582140110271-c78d648907a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwZmFtaWx5JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1NjA0MDk2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "genealogy",
    name: "Genealogy",
    kicker: "Chapter VIII",
    blurb: "Records, DNA, archives — the discipline of finding what was almost lost.",
    count: "97 archives",
    span: "square",
    image: "https://images.unsplash.com/photo-1542216515-4e6a586c1ca0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwZmFtaWx5JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1NjA0MDk2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "local-history",
    name: "Local History",
    kicker: "Chapter IX",
    blurb: "Villages, streets and ancestral homes — the geography of memory.",
    count: "5,431 places",
    span: "wide",
    image: "https://images.unsplash.com/photo-1569783721854-33a99b4c0bae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxtdXNldW0lMjBnYWxsZXJ5JTIwZXhoaWJpdGlvbnxlbnwwfHx8fDE3ODU2MDQxMDl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "family-stories",
    name: "Family Stories",
    kicker: "Chapter X",
    blurb: "Recipes, letters, songs and oral histories — the folklore of a family.",
    count: "18,760 stories",
    span: "square",
    image: "https://images.pexels.com/photos/3617536/pexels-photo-3617536.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Every family is an archive.",
    body: "Behind every surname is a migration, a marriage, a monsoon that changed everything. We build the shelves those stories deserve.",
  },
  {
    n: "02",
    title: "Memory is a shared craft.",
    body: "Grandmothers, cousins, neighbours, historians — the truth of a life is co-authored. Our pages are collaborative, forever editable.",
  },
  {
    n: "03",
    title: "Respect precedes reach.",
    body: "We distinguish documented fact from family tradition from community contribution. Nothing sensational. Everything sourced.",
  },
  {
    n: "04",
    title: "The page outlives the platform.",
    body: "Photographs, letters and voices archived here are held for generations, not seasons. Legacy is the metric.",
  },
];

export const MARQUEE_WORDS = [
  "Legacy", "Ancestry", "Memory", "Lineage",
  "Generations", "Migration", "Homecoming", "Kin",
  "Chronicle", "Threshold", "Heirloom", "Origin",
];

export const TODAY = [
  { date: "12 · 04", note: "Birth anniversary of Margaret Mead, pioneering anthropologist of family and kinship.", tag: "Anniversary" },
  { date: "12 · 04", note: "The Whitmore house of Yorkshire records its 214th founding day.", tag: "House" },
  { date: "12 · 04", note: "Memorial candles lit for veterans of the 1962 harbour rescue.", tag: "Memorial" },
];

export const SPOTLIGHT = {
  house: "The Whitmore House of Yorkshire",
  years: "1812 — Present",
  region: "Yorkshire · Ontario · Diaspora",
  intro:
    "Six generations of clergy, schoolteachers, engineers and emigrants — traced from a single Yorkshire parish to universities across three continents.",
  stats: [
    { k: "Documented ancestors", v: "412" },
    { k: "Photographs archived", v: "1,204" },
    { k: "Migration routes", v: "17" },
    { k: "Living members", v: "286" },
  ],
  image:
    "https://images.pexels.com/photos/9678207/pexels-photo-9678207.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const MEMORY_WALL = [
  { name: "Emma, London", remembering: "Nana — Margaret Bennett", message: "The garden still smells of you, especially in early spring." },
  { name: "James, New York", remembering: "Grandpa — Robert Kelly", message: "Every baseball game, I still hear your voice from the bleachers." },
  { name: "Sofia, Rome", remembering: "Nonno — Giuseppe Rossi", message: "Your record collection is still turning. Every song remembers you." },
  { name: "Claire, Toronto", remembering: "Grandma — Eleanor Hayes", message: "The apple pie recipe finally worked. I think you were watching." },
  { name: "Michael, Sydney", remembering: "Dad — David Whitfield", message: "I finally read all your letters. You were writing to me." },
  { name: "Isabelle, Paris", remembering: "Grand-mère — Colette Marchand", message: "Every festival we set your plate. Nobody has said no yet." },
];

export const RESEARCH = [
  { n: "R.01", title: "Reading a parish register", read: "6 min" },
  { n: "R.02", title: "Digitising a great-grandmother's letters", read: "9 min" },
  { n: "R.03", title: "How to interview an elder without a script", read: "12 min" },
  { n: "R.04", title: "The ethics of naming — surnames and consent", read: "7 min" },
];

/*  Sample family trees curated for the directory. When SocialPulse data comes
    online, this list will be sourced from the API. Each entry links to a future
    detail page — for now they navigate to the Family Tree wing article. */
export const FAMILY_TREES = [
  {
    id: "bennett-kent",
    name: "The Bennetts of Kent",
    lineage: "English gentry · Anglican tradesmen",
    region: "Canterbury · London · Melbourne",
    years: "1712 — Present",
    members: 386,
    generations: 9,
    documents: 1102,
  },
  {
    id: "rossi-firenze",
    name: "House of Rossi",
    lineage: "Tuscan artisans · Florentine goldsmiths",
    region: "Firenze · New York · Buenos Aires",
    years: "1648 — Present",
    members: 512,
    generations: 12,
    documents: 1440,
  },
  {
    id: "kelly-boston",
    name: "The Kelly Family",
    lineage: "Irish-American · Bostonian civic",
    region: "County Cork · Boston · San Francisco",
    years: "1849 — Present",
    members: 298,
    generations: 6,
    documents: 764,
  },
  {
    id: "marchand-paris",
    name: "The Marchand Line",
    lineage: "French bourgeois · Parisian booksellers",
    region: "Paris · Lyon · Montréal",
    years: "1782 — Present",
    members: 244,
    generations: 8,
    documents: 921,
  },
  {
    id: "whitfield-sydney",
    name: "The Whitfields",
    lineage: "Anglo-Australian pastoralists",
    region: "Sydney · Hobart · Auckland",
    years: "1810 — Present",
    members: 176,
    generations: 6,
    documents: 480,
  },
  {
    id: "van-der-berg-utrecht",
    name: "The Van der Berg House",
    lineage: "Dutch shipping merchants",
    region: "Utrecht · Rotterdam · Cape Town",
    years: "1667 — Present",
    members: 341,
    generations: 11,
    documents: 909,
  },
  {
    id: "schneider-berlin",
    name: "The Schneider Family",
    lineage: "Prussian civil servants · Berliners",
    region: "Berlin · Hamburg · Chicago",
    years: "1795 — Present",
    members: 220,
    generations: 7,
    documents: 555,
  },
  {
    id: "abelard-quebec",
    name: "The Abélard Line",
    lineage: "Québécois habitants",
    region: "Trois-Rivières · Montréal · Vermont",
    years: "1728 — Present",
    members: 190,
    generations: 8,
    documents: 402,
  },
  {
    id: "kim-seoul",
    name: "The Kim Household",
    lineage: "Korean scholars · Seoul merchants",
    region: "Seoul · Los Angeles · Vancouver",
    years: "1830 — Present",
    members: 210,
    generations: 7,
    documents: 640,
  },
  {
    id: "adebayo-lagos",
    name: "The Adebayo Family",
    lineage: "Yoruba merchant house",
    region: "Lagos · London · Atlanta",
    years: "1892 — Present",
    members: 148,
    generations: 5,
    documents: 320,
  },
];

export const AUTH_URL = "https://socialpulse.com/auth";
export const AUTH_LOGIN_URL = "https://socialpulse.com/auth/login";
export const AUTH_SIGNUP_URL = "https://socialpulse.com/auth/signup";

// Brand assets
export const LOGO_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_memory-preserve-8/artifacts/34s1rj6o_AC54EE0C-91CC-4070-B8FF-3F5400BA7870.png";

// Canonical external URLs used across editorial content.
export const MFT_URL = "https://www.myfamilytree.care";
export const SP_URL = "https://www.socialpulse.com";

// External network sites
export const NETWORK_SITES = [
  { label: "Social Pulse", href: "https://www.socialpulse.com", external: true },
  { label: "Food Pulse", href: "https://foodpulse.net", external: true },
  { label: "India", href: "https://www.indianfamilytree.com", external: true, note: "IndianFamilyTree" },
];

export const GLOBAL_COUNTRIES = [
  { code: "us", name: "United States", region: "Americas" },
  { code: "ca", name: "Canada", region: "Americas" },
  { code: "mx", name: "Mexico", region: "Americas" },
  { code: "br", name: "Brazil", region: "Americas" },
  { code: "gb", name: "United Kingdom", region: "Europe" },
  { code: "ie", name: "Ireland", region: "Europe" },
  { code: "fr", name: "France", region: "Europe" },
  { code: "de", name: "Germany", region: "Europe" },
  { code: "it", name: "Italy", region: "Europe" },
  { code: "es", name: "Spain", region: "Europe" },
  { code: "pt", name: "Portugal", region: "Europe" },
  { code: "in", name: "India", region: "Asia" },
  { code: "pk", name: "Pakistan", region: "Asia" },
  { code: "bd", name: "Bangladesh", region: "Asia" },
  { code: "lk", name: "Sri Lanka", region: "Asia" },
  { code: "np", name: "Nepal", region: "Asia" },
  { code: "cn", name: "China", region: "Asia" },
  { code: "jp", name: "Japan", region: "Asia" },
  { code: "kr", name: "Korea", region: "Asia" },
  { code: "sg", name: "Singapore", region: "Asia" },
  { code: "my", name: "Malaysia", region: "Asia" },
  { code: "id", name: "Indonesia", region: "Asia" },
  { code: "th", name: "Thailand", region: "Asia" },
  { code: "vn", name: "Vietnam", region: "Asia" },
  { code: "ph", name: "Philippines", region: "Asia" },
  { code: "ae", name: "UAE", region: "Middle East" },
  { code: "sa", name: "Saudi Arabia", region: "Middle East" },
  { code: "il", name: "Israel", region: "Middle East" },
  { code: "tr", name: "Türkiye", region: "Middle East" },
  { code: "eg", name: "Egypt", region: "Africa" },
  { code: "ke", name: "Kenya", region: "Africa" },
  { code: "ng", name: "Nigeria", region: "Africa" },
  { code: "za", name: "South Africa", region: "Africa" },
  { code: "et", name: "Ethiopia", region: "Africa" },
  { code: "au", name: "Australia", region: "Oceania" },
  { code: "nz", name: "New Zealand", region: "Oceania" },
];

/** Country wing profiles — authored genealogy notes for the GLOBAL atlas pages. */
export const COUNTRY_PROFILES = {
  us: { note: "A nation of arrivals — Ellis Island manifests, census rolls from 1790, church registers and freedmen's records carry most American families back across an ocean.", records: ["Census rolls (1790–1950)", "Ellis Island manifests", "Vital records offices", "Freedmen's Bureau archives"] },
  ca: { note: "Loyalist rolls, Hudson's Bay ledgers and parish books of Québec hold three centuries of Canadian family memory, from Acadian deportations to Prairie homesteads.", records: ["Library & Archives Canada", "Québec parish registers", "Census of 1851 onward", "Homestead files"] },
  mx: { note: "Mexican roots run through civil registers since 1859, colonial Catholic baptismals, and indigenous community records that predate both.", records: ["Registro Civil", "Catholic parish books", "1930 national census", "Community land records"] },
  br: { note: "Brazilian families trace through parish registers, cartório civil records, and the arrival books of Salvador, Santos and Rio — African, Portuguese, Italian, Japanese and indigenous lines.", records: ["Cartórios (civil registry)", "Parish baptismals", "Immigration museum archives", "1888 abolition records"] },
  gb: { note: "Parish registers from 1538, civil registration from 1837 and decennial censuses since 1841 make Britain one of the richest genealogical landscapes on earth.", records: ["GRO birth/marriage/death index", "1841–1921 censuses", "Parish registers", "Probate calendars"] },
  ie: { note: "Ireland's story is written in Griffith's Valuation, the 1901 and 1911 censuses, and parish books that survived fire and famine — and in the diaspora that carried the names abroad.", records: ["1901 & 1911 census", "Griffith's Valuation", "Catholic parish registers", "Emigrant ship lists"] },
  fr: { note: "French état civil registers have recorded every birth, marriage and death since 1792 — departmental archives put most of them a click away.", records: ["État civil registers", "Departmental archives", "Notarial records", "1792 civil registration"] },
  de: { note: "German family lines thread through church books (Kirchenbücher), civil Standesamt registers from 1876, and the emigration lists of Hamburg and Bremen.", records: ["Kirchenbücher", "Standesamt registers", "Hamburg departure lists", "Ortsfamilienbücher"] },
  it: { note: "Italy keeps its families in anagrafe town registries, Napoleonic-era civil records, and parish sacramental books — often unbroken since the 1500s.", records: ["Stato civile", "Parish sacramental books", "Port of Naples arrivals", "FamilySearch Italian records"] },
  es: { note: "Spanish padrón municipal rolls, parish registers and notarial protocols reach back five centuries — and across the Atlantic to every corner of the old empire.", records: ["Registro Civil (1870–)", "Parish registers", "Padrón municipal", "Indies archive, Seville"] },
  pt: { note: "Portugal's assentos paroquiais and the Torre do Tombo archive hold one of Europe's oldest continuous paper trails, from village baptisms to the fleets of the Discoveries.", records: ["Torre do Tombo", "Parish assentos", "Civil registry 1911–", "Emigration consulates"] },
  in: { note: "Indian genealogy lives in kuldevi lineages, gotra records, temple registers, family bakhars and the pandit archives of Haridwar and Varanasi — some unbroken for five hundred years.", records: ["Haridwar & Varanasi pandit bahis", "Family bakhars", "Temple registers", "Village land records"] },
  pk: { note: "Pakistani families trace through gotra and tribal genealogies, Sufi shrine records, land settlement papers and the Partition-era registers that divided millions of family books.", records: ["Shrine & sajjada records", "Land settlement registers", "NADRA family records", "Partition-era files"] },
  bd: { note: "Bengali family memory flows through kulin genealogies, village deeds, and the records of rivers and railways that moved families across Bengal for centuries.", records: ["Kulin genealogies", "Village record-of-rights", "Civil registration", "Colonial gazetteers"] },
  lk: { note: "Sri Lanka's tombo registers — Portuguese and Dutch colonial censuses of land and families — are among Asia's oldest continuous genealogical records.", records: ["Dutch tombos", "Civil registration 1867–", "Temple lands records", "Plantation rolls"] },
  np: { note: "Nepali lineages are guarded by kul priests, guthi trust records and the gotra traditions of hill and Terai families alike.", records: ["Guthi trust archives", "Kul priest registers", "Land revenue records", "Civil registration 1977–"] },
  cn: { note: "China's jiapu — clan genealogies — are the oldest continuous family records on earth, some charting eighty generations of a single surname.", records: ["Jiapu clan genealogies", "Ancestral hall tablets", "Imperial examination rolls", "Village gazetteers"] },
  jp: { note: "Japan's koseki family registry, begun in 1872, records every household with a precision few nations match — temple terauke registers reach further back.", records: ["Koseki family registry", "Terauke temple registers", "1872 Meiji reforms", "Emigration bureau files"] },
  kr: { note: "Korean jokbo clan books, renewed every generation, map millions of descendants to single founding ancestors — Gyeongju Kim, Jeonju Yi, Miryang Park.", records: ["Jokbo clan genealogies", "Joseon household registers", "Clan village records", "1920s colonial census"] },
  sg: { note: "Singapore's families arrived with the straits trade — Chinese clan association rolls, Indian Muslim mosque registers and colonial census books tell the story.", records: ["Clan association rolls", "Colonial censuses", "Mosque & temple registers", "National Archives of Singapore"] },
  my: { note: "Malaysian roots braid Malay village lineages, Chinese kongsi records and Indian plantation registers into one peninsula's family memory.", records: ["Kongsi & clan records", "Estate labour rolls", "Civil registration", "Mosque committee archives"] },
  id: { note: "Indonesian family history crosses a thousand islands — Javanese court genealogies, Balinese banjar records, Minangkabau matrilineal suku and Bugis seafaring lineages.", records: ["Court genealogies (Babad)", "Banjar village rolls", "Dutch civil registers", "Suku lineage keepers"] },
  th: { note: "Thai families adopted surnames only in 1913 — before that, temple records, royal chronicles and village memory carry the line.", records: ["1913 surname registers", "Wat temple records", "Royal chronicles", "Civil registration"] },
  vn: { note: "Vietnamese gia phả family annals, kept at ancestral halls, chart patrilineal descent with Confucian care across dynasties and diasporas.", records: ["Gia phả family annals", "Ancestral halls", "Communal house records", "Colonial état civil"] },
  ph: { note: "The Catálogo alfabético de apellidos gave Filipinos surnames in 1849; church libros de bautismo carry families three centuries deeper.", records: ["Church libros (baptism/marriage/burial)", "1849 apellido catalogue", "Civil registry", "Spanish colonial padrones"] },
  ae: { note: "Emirati family lines are carried by tribal genealogies of the Bani Yas and other houses, pearl-diving crew lists and the oral majlis tradition now being written down.", records: ["Tribal genealogies", "Pearl-diving crew lists", "Court & majlis records", "National archives, Abu Dhabi"] },
  sa: { note: "Saudi families hold nasab genealogies recited and written for centuries — tribal, mercantile and scholarly lines reaching deep into the peninsula.", records: ["Nasab genealogies", "Tribal records", "Endowment (waqf) deeds", "Civil affairs registry"] },
  il: { note: "Israeli family archives gather diaspora records from a hundred lands — Ottoman registers, European community books and the immigration lists of the return.", records: ["Central Zionist Archives", "Ottoman population registers", "Immigration ship lists", "Community record books"] },
  tr: { note: "Türkiye's families pass through Ottoman tahrir tax registers, 1831 census rolls, and the nüfus population system begun at empire's end.", records: ["Ottoman tahrir registers", "1831 census", "Nüfus family registers", "Waqf charters"] },
  eg: { note: "Egyptian genealogy flows from Nile village registers, waqf endowment deeds, and civil records begun under Muhammad Ali — Coptic and Muslim lines alike.", records: ["Civil registry (1836–)", "Waqf deeds", "Coptic church registers", "Nile village rolls"] },
  ke: { note: "Kenyan families hold clan genealogies in oral tradition and mission registers — Kikuyu mbari, Luo dhoot lineages, coastal Swahili houses.", records: ["Mission registers", "Clan & mbari genealogies", "Colonial native registers", "Civil registration 1906–"] },
  ng: { note: "Nigerian lineages are vast — Yoruba oríkì praise-poetry genealogies, Igbo umunna councils, Hausa-Fulani emirate records and mission books.", records: ["Oríkì oral genealogies", "Emirate records", "Mission registers", "Civil registration"] },
  za: { note: "South African family history crosses settler, indigenous and enslaved lines — Cape Dutch Reformed registers, mission rolls and the records of the mines.", records: ["Cape church registers (1665–)", "Mission station rolls", "Deeds office", "Mines compound records"] },
  et: { note: "Ethiopia keeps one of Africa's oldest written genealogies — royal chronicles, Ge'ez church manuscripts and clan traditions of the highlands.", records: ["Royal chronicles", "Ge'ez church manuscripts", "Clan genealogies", "Land tenure records"] },
  au: { note: "Australian families begin with the convict musters and free-settler shipping lists, continuing through gold-rush rushes and soldier-settler blocks.", records: ["Convict musters", "Shipping lists", "BDM registries", "Trove newspapers"] },
  nz: { note: "Aotearoa's lines braid Māori whakapapa — recited genealogies of canoe ancestors — with settler shipping lists and civil registers from 1848.", records: ["Whakapapa records", "Civil registration 1848–", "Shipping lists", "Māori Land Court minutes"] },
};
